export const APP_SECRET = {
  APP_SECRET: "this_is_a_token_for_the_backoffice_app"
};
